import { useState } from "react";
import "../QuestionRadio/QuestionRadio.scss";
import "./QuestionCheckbox.scss";
import ButtonSubmit from "../ButtonSubmit";
import ProgressDots from "../ProgressDots/ProgressDots";
import { simplyClick } from "../../helpers";
import CheckboxOption from "./CheckboxOption";
import { useWizardAnswers } from "ui-components";
import { stepFieldMap } from "../../constants/index";
function QuestionCheckbox({
  nextStep,
  step,
  options,
  title,
  activeDot,
  eventOption,
  eventAction,
}) {
  const [selected, setSelected] = useState([]);
  const [errorChoose, setErrorChoose] = useState(null);
  const updateAnswer = useWizardAnswers();
  const optionEntries = Object.entries(options);
  const field = stepFieldMap[step];
  const isNextDisabled = selected.length < 3 || selected.length > 5;
  const limitReached = selected.length >= 5;

  const handleSelect = (optionValue, index) => {
    setSelected((prevSelected) => {
      let newSelected;

      if (prevSelected.includes(index)) {
        newSelected = prevSelected.filter((i) => i !== index);
      } else {
        if (prevSelected.length >= 5) return prevSelected;
        newSelected = [...prevSelected, index];
      }

      if (errorChoose) setErrorChoose(null);

      if (field) {
        const allSelected = newSelected.map((i) => String(i + 1));
        updateAnswer({ [field]: allSelected });
      }
      const selectedLabels = newSelected.map((i) => optionEntries[i][0]);

      simplyClick(eventOption, {
        text: selectedLabels.join(", "),
      });

      return newSelected;
    });
  };

  const handleAction = (action) => {
    if (action === "skip") {
      if (field) updateAnswer({ [field]: ["0"] });
      simplyClick(eventAction, { text: action });
      nextStep();
      return;
    }

    if (action === "next") {
      if (selected.length === 0) {
        if (field) updateAnswer({ [field]: ["0"] });
        simplyClick(eventAction, { text: action });
        nextStep();
        return;
      }

      if (selected.length < 3) {
        setErrorChoose("Please choose at least 3 options");
        simplyClick("err_lnd_topics_choose_3_options");
        return;
      }

      if (field) {
        const allSelected = selected.map((i) => String(i + 1));
        updateAnswer({ [field]: allSelected });
      }

      simplyClick(eventAction, { text: action });
      nextStep();
    }
  };

  return (
    <div className="radio__form-wrapper">
      <div className="user__form-top">
        <h3>About me</h3>
      </div>

      <div className="question__form-content">
        <p className="title_question_check">{title}</p>

        <div className="text__wrapper">
          <ul className="checkbox__list">
            {optionEntries.map(([label, value], index) => (
              <CheckboxOption
                key={index}
                label={label}
                value={value}
                selected={selected.includes(index)}
                onSelect={() => handleSelect(value, index)}
                disabled={limitReached && !selected.includes(index)}
              />
            ))}
          </ul>
        </div>

        {errorChoose && <p className="errorChoose">{errorChoose}</p>}

        <div className="btn_group btn_check">
          <ButtonSubmit
            onClick={() => handleAction("skip")}
            className="button__global button_skip"
            text="SKIP"
          />
          <ButtonSubmit
            onClick={() => handleAction("next")}
            className="button__global"
            text="NEXT"
          />
        </div>

        <ProgressDots total={12} activeCount={activeDot} />
      </div>
    </div>
  );
}

export default QuestionCheckbox;
